import React from 'react';
import { GENDER } from '@src/constants/voice';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import Search from './Search';
import { StyledVoicesSearch } from './index.style';

const VoicesFilter = ({
  filterOpens,
  onChangeFilterOpens,
  filter = {},
  onChangeFilter,
  defaultLanguageFilter,
  languageOptions,
  onHandleReset,
}) => {
  const { t } = useTranslation();

  return (
    <StyledVoicesSearch>
      <div className="header">
        <Typography className="title">{t('quickFilter')}</Typography>
        <Typography className="reset" onClick={onHandleReset}>
          {t('reset')}
        </Typography>
      </div>
      <Search
        search={filter}
        value={filter.languageCode}
        options={languageOptions}
        name="languageCode"
        title="language"
        open={filterOpens.languageCode}
        onChange={onChangeFilter}
        onChangeOpen={onChangeFilterOpens}
        isLanguageFilter
        defaultLanguageFilter={defaultLanguageFilter}
        languageOptions
      />
      <Search
        search={filter}
        value={filter.gender}
        options={GENDER}
        name="gender"
        open={filterOpens.gender}
        onChange={onChangeFilter}
        onChangeOpen={onChangeFilterOpens}
        defaultLanguageFilter={defaultLanguageFilter}
      />
    </StyledVoicesSearch>
  );
};

export default VoicesFilter;
